// hooks
import * as React from 'react'
import { useContext } from 'react'
// libs
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
// context
import { StrategyActionsBLContext } from 'containers/StrategyActions/layers/BL'

const InnerWrapper = styled(Grid)`
  && {
    width: unset;

    & > :first-child {
      font-size: 24px;
      margin-top: 16px;
    }

    & > :last-child {
      font-size: 18px;

      @media (max-width: 768px) {
        font-size: 16px;
      }
    }
  }
`

const InfoPanel: React.FC = () => {
  const { assignmentsAmount, overdueAmount } = useContext(StrategyActionsBLContext)

  return (
    <Grid container direction={'row'}>
      <InnerWrapper container direction={'column'}>
        <Grid>{`You have ${assignmentsAmount} assignment this week and ${overdueAmount} overdue`}</Grid>
      </InnerWrapper>
    </Grid>
  )
}

export default InfoPanel
